const columns = [
  {
    name: 'Type',
    selector: (row) => row?.name,
  },
  {
    name: 'Count',
    selector: (row) => row?.count,
  },
  
]

export { columns };
